module.exports = __webpack_public_path__ + "img/apple-badge.a2c2250d.png";